const SITES = ["choice", "global", "umrah"];
const LANGS = ["ru", "en", "tr", "tm"];
const SITE_LANGS = {
  choice: ["ru", "en", "tm"],
  global: ["ru", "en"],
  umrah: ["tm", "ru"]
};
const DEFAULT_LANG = {
  choice: "ru",
  global: "ru",
  umrah: "tm"
};
const LANG_NAMES = {
  ru: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439",
  en: "English",
  tr: "T\xFCrk\xE7e",
  tm: "T\xFCrkmen"
};
const BCP47 = {
  ru: "ru",
  en: "en",
  tr: "tr",
  tm: "tk"
};
function bcp47(lang) {
  return BCP47[lang];
}
function isSiteLang(site, value) {
  return SITE_LANGS[site].includes(value);
}
const SITE_CURRENCY = {
  choice: "USD",
  global: "USD",
  umrah: "TMT"
};

export { BCP47, DEFAULT_LANG, LANGS, LANG_NAMES, SITES, SITE_CURRENCY, SITE_LANGS, bcp47, isSiteLang };
//# sourceMappingURL=constants.js.map
//# sourceMappingURL=constants.js.map